:root {
  --sellalong-heading-font: "DIN Next", sans-serif;
  --sellalong-heading-font-size: 22px;
  --sellalong-heading-font-weight: normal;
  --sellalong-label-font: "DIN Next", sans-serif;
  --sellalong-text-font: "New York", Iowan Old Style, Apple Garamond,
    Baskerville, Times New Roman, Droid Serif, Times, Source Serif Pro, serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  --sellalong-colour-text: #3d3d3d;
  --sellalong-colour-text-light: #7e7e7e;
  --sellalong-control-font: "DIN Next", sans-serif;
  --sellalong-colour-primary: #202020;
  --sellalong-colour-primary-tint: #202020;
  --sellalong-colour-secondary: #202020;
  --sellalong-colour-secondary-tint: #202020;
}
